import React, { useEffect, useState, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { hireRegistrationNextStep, setHireRegistrationFormData } from '../../redux/slice/commonSlice'
import { fetchSpecialization } from '../../redux/action/commonAction'
import { HiringStep1 } from '../../constants/ImagePaths'
import Image from '../../components/general/Image'
import { DoubleStar } from "../../constants/ImagePaths"
import SkillCard from '../../components/hire-developer/SkillCard'
import Button from '../../components/general/Button'
import { toast } from 'react-toastify'
const DeveloperType = () => {
  const dispatch = useDispatch()
  const [activeSpecialization, setActiveSpecialization] = useState(null)
  const { isLoading, specializationList } = useSelector(state => state.common.spec);
  const { hire_registration: { stepOneData: { specialization } } } = useSelector(state => state.common);

  useEffect(() => {
    if (!isLoading) return;
    dispatch(fetchSpecialization())
    // eslint-disable-next-line
  }, [isLoading])

  const popularSpecialization = useMemo(() => {
    return specializationList.filter(spec => spec.technology_type === 'POPULAR');
  }, [specializationList])

  const otherSpecialization = useMemo(() => {
    return specializationList.filter(spec => spec.technology_type !== 'POPULAR');
  }, [specializationList])

  const handleSubmit = () => {
    if(!activeSpecialization) {
      toast.error('Please select a specialization')
      return;
    }

    dispatch(hireRegistrationNextStep())
  }

  return (
    <div className="hireosDevsprojectsCon text-white py-[30px] lg:flex lg:justify-between lg:items-start lg:gap-[30px]">
      <div className="project-Image lg:w-[30%]">
        <figure>
          <Image src={HiringStep1} alt="hire-step-img1" />
        </figure>
      </div>
      <div className="projectStep mt-[30px] lg:mt-0 lg:w-[60%]">
        <div className="text-[14px] text-primary-color">1/3</div>
        <h3 className="text-[30px] lg:text-[1.7rem] font-bold flex justify-start">
          <span>Who’s the next developer for your team?</span>
          <Image src={DoubleStar} alt="double-star" className="w-[40px] h-[40px] hidden lg:block ml-[10px]" />
        </h3>

        {
          popularSpecialization.length > 0 && (
            <div className='mt-[20px]'>
              <p className='text-primary-color mb-[10px]'>Most Popular</p>
              <div className='grid grid-cols-2 md:grid-cols-4 gap-[10px]'>
                {
                  popularSpecialization.map((specialization, index) => (
                    <div key={index}>
                      <SkillCard extraClass='lg:h-[100px]' onClick={() => {
                        setActiveSpecialization(specialization.id)
                        dispatch(setHireRegistrationFormData({
                          formData: {
                            specialization: specialization.id
                          }
                        }))
                      }} keyName={index} icon={specialization.icon_details ? specialization.icon_details.file : ''} name={specialization.name} isActive={activeSpecialization === specialization.id} />
                    </div>
                  ))
                }
              </div>
            </div>
          )
        }

        <div className='mt-[20px]'>
          <p className='text-primary-color mb-[10px]'>Other Developers</p>
          <div className='grid grid-cols-2 md:grid-cols-4 gap-[10px] lg:max-h-[200px] lg:overflow-y-auto'>
            {
              otherSpecialization.map((specialization, index) => (
                <SkillCard
                  extraClass='lg:h-[100px]'
                  onClick={() => {
                    setActiveSpecialization(specialization.id)
                    dispatch(setHireRegistrationFormData({
                      formData: {
                        specialization: specialization.id
                      }
                    }))
                  }} key={index} icon={specialization.icon_details ? specialization.icon_details.file : ''} name={specialization.name} isActive={activeSpecialization === specialization.id} />
              ))
            }
          </div>
        </div>

        <Button className='bg-primary-color text-black w-full md:w-[200px] h-[40px] lg:h-[60px] mt-[20px] rounded text-[0.9rem]' disabled={!Boolean(specialization)} onClick={handleSubmit}> Get Started </Button>
      </div>
    </div>

  )
}

export default DeveloperType